<!-- Sidebar for desktop -->
<aside
  class="hidden lg:fixed lg:inset-y-0 lg:flex lg:flex-col bg-white dark:bg-gray-950 border-r border-gray-200 dark:border-gray-800 text-gray-900 dark:text-gray-100 transition-all duration-300 ease-in-out z-40"
  [class.lg:w-64]="!isSidebarCollapsed()"
  [class.lg:w-20]="isSidebarCollapsed()"
>
  <div class="flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
    <div
      class="flex items-center justify-center h-16 px-4 border-b border-gray-200 dark:border-gray-800 shrink-0"
    >
      @if (!isSidebarCollapsed()) {
        <div class="flex items-center gap-2 animate-in fade-in duration-300">
          <img src="/images/miyzan-logo.png" alt="Miyzan" class="h-8 w-auto" />
          <span class="text-xl font-bold tracking-widest text-gray-900 dark:text-gray-100"
            >MIYZAN</span
          >
        </div>
      } @else {
        <img src="/images/miyzan-logo.png" alt="Miyzan" class="h-8 w-auto object-contain" />
      }
    </div>

    <!-- @if (showStoreSelector()) {
      <div class="p-4 border-b border-gray-200 dark:border-gray-800 shrink-0">
        @if (!isSidebarCollapsed()) {
          <label class="sr-only" for="sidebar-store">{{
            'SIDEBAR.STORE_FILTER' | translate
          }}</label>
          <select
            id="sidebar-store"
            class="w-full text-sm rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-2 py-2 text-gray-900 dark:text-gray-100"
            [value]="storeContext.selectedStoreId() ?? ''"
            (change)="onStorePick($event)"
          >
            <option value="">{{ 'SIDEBAR.ALL_STORES' | translate }}</option>
            @for (s of storeContext.stores(); track s.id) {
              <option [value]="s.id">{{ s.name }}</option>
            }
          </select>
        } @else {
          <div
            class="w-full flex justify-center py-2 text-xs font-bold text-green-600 dark:text-green-400"
            [attr.title]="storeContext.selectedStore()?.name ?? ('SIDEBAR.ALL_STORES' | translate)"
          >
            {{ (storeContext.selectedStore()?.name ?? '∗').substring(0, 1) }}
          </div>
        }
      </div>
    } -->

    <nav class="flex-1 p-4 space-y-1">
      @for (item of visibleNav(); track item.translateKey; let i = $index) {
        <!-- Ketma-ket bir xil `section`ga ega elementlar bitta sarlavha ostida
             ko'rsatiladi — oldingi KO'RINADIGAN element bilan solishtiriladi,
             shuning uchun ruxsat bo'yicha yashirilgan elementlar bo'sh sarlavha
             qoldirmaydi. -->
        @if (item.section && item.section !== visibleNav()[i - 1]?.section) {
          @if (!isSidebarCollapsed()) {
            <div class="px-3 pt-4 pb-1">
              <span
                class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                >{{ item.section | translate }}</span
              >
            </div>
          } @else {
            <div class="my-2 mx-3 border-t border-gray-200 dark:border-gray-800"></div>
          }
        }
        <a
          [routerLink]="item.href"
          routerLinkActive="bg-green-50 dark:bg-green-900/50 text-green-600 dark:text-green-400 shadow-sm"
          [routerLinkActiveOptions]="{ exact: item.href === '/app' }"
          class="flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 group relative"
          [class.justify-center]="isSidebarCollapsed()"
        >
          <lucide-icon [img]="item.icon" class="w-5 h-5 shrink-0"></lucide-icon>
          @if (!isSidebarCollapsed()) {
            <span
              class="truncate text-sm font-medium animate-in slide-in-from-left-2 duration-300"
              >{{ item.translateKey | translate }}</span
            >
          } @else {
            <div
              class="absolute left-full ml-4 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all whitespace-nowrap z-50"
            >
              {{ item.translateKey | translate }}
            </div>
          }
        </a>
      }

      @if (isAdminUser()) {
        <div class="pt-2 mt-2 border-t border-gray-200 dark:border-gray-700">
          <a
            routerLink="/admin"
            routerLinkActive="bg-purple-50 dark:bg-purple-900/40 text-purple-600 dark:text-purple-400 shadow-sm"
            class="flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 group relative"
            [class.justify-center]="isSidebarCollapsed()"
          >
            <lucide-icon [img]="Shield" class="w-5 h-5 shrink-0"></lucide-icon>
            @if (!isSidebarCollapsed()) {
              <span
                class="truncate text-sm font-medium animate-in slide-in-from-left-2 duration-300"
                >{{ 'SIDEBAR.ADMIN' | translate }}</span
              >
            } @else {
              <div
                class="absolute left-full ml-4 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all whitespace-nowrap z-50"
              >
                {{ 'SIDEBAR.ADMIN' | translate }}
              </div>
            }
          </a>
        </div>
      }
    </nav>
  </div>

  <div class="p-4 border-t border-gray-200 dark:border-gray-800 shrink-0 hidden lg:block">
    <button
      (click)="toggleSidebarCollapse()"
      class="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200"
      [class.justify-center]="isSidebarCollapsed()"
    >
      <lucide-icon
        [img]="isSidebarCollapsed() ? PanelLeftOpen : PanelLeftClose"
        class="w-5 h-5"
      ></lucide-icon>
      @if (!isSidebarCollapsed()) {
        <span class="text-sm font-medium">{{ 'SIDEBAR.COLLAPSE' | translate }}</span>
      }
    </button>
  </div>
</aside>

@if (isSidebarOpen()) {
  <div class="fixed inset-0 z-50 lg:hidden">
    <button
      class="fixed inset-0 bg-gray-600/75"
      (click)="closeSidebar()"
      [attr.aria-label]="'SIDEBAR.CLOSE' | translate"
    ></button>
    <aside
      class="fixed inset-y-0 left-0 flex flex-col w-64 bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100"
    >
      <div
        class="flex items-center justify-between h-16 px-6 border-b border-gray-200 dark:border-gray-800"
      >
        <div class="flex items-center gap-2">
          <img src="/images/miyzan-logo.png" alt="Miyzan" class="h-8 w-auto" />
          <span class="text-xl font-bold tracking-widest text-gray-900 dark:text-gray-100"
            >MIYZAN</span
          >
        </div>
        <button
          class="p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md"
          (click)="closeSidebar()"
        >
          <lucide-icon name="x" [img]="X" class="w-6 h-6"></lucide-icon>
        </button>
      </div>

      <!-- @if (showStoreSelector()) {
        <div class="p-3 border-b border-gray-200 dark:border-gray-800">
          <label class="sr-only" for="mobile-sidebar-store">{{
            'SIDEBAR.STORE_FILTER' | translate
          }}</label>
          <select
            id="mobile-sidebar-store"
            class="w-full text-sm rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-2 py-2"
            [value]="storeContext.selectedStoreId() ?? ''"
            (change)="onStorePick($event)"
          >
            <option value="">{{ 'SIDEBAR.ALL_STORES' | translate }}</option>
            @for (s of storeContext.stores(); track s.id) {
              <option [value]="s.id">{{ s.name }}</option>
            }
          </select>
        </div>
      } -->

      <nav class="flex-1 p-4 space-y-1 overflow-y-auto">
        @for (item of visibleNav(); track item.translateKey; let i = $index) {
          @if (item.section && item.section !== visibleNav()[i - 1]?.section) {
            <div class="px-3 pt-4 pb-1">
              <span
                class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                >{{ item.section | translate }}</span
              >
            </div>
          }
          <a
            [routerLink]="item.href"
            routerLinkActive="bg-green-50 dark:bg-green-900/50 text-green-600 dark:text-green-400"
            [routerLinkActiveOptions]="{ exact: item.href === '/app' }"
            (click)="closeSidebar()"
            class="flex items-center gap-3 px-3 py-2 rounded-lg transition-colors text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            <lucide-icon [img]="item.icon" class="w-5 h-5"></lucide-icon>
            <span>{{ item.translateKey | translate }}</span>
          </a>
        }
        @if (isAdminUser()) {
          <div class="pt-2 mt-2 border-t border-gray-200 dark:border-gray-700">
            <a
              routerLink="/admin"
              routerLinkActive="bg-purple-50 dark:bg-purple-900/40 text-purple-600 dark:text-purple-400"
              (click)="closeSidebar()"
              class="flex items-center gap-3 px-3 py-2 rounded-lg transition-colors text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
            >
              <lucide-icon [img]="Shield" class="w-5 h-5"></lucide-icon>
              <span>{{ 'SIDEBAR.ADMIN' | translate }}</span>
            </a>
          </div>
        }
      </nav>
    </aside>
  </div>
}
